import { AGE_GROUPS, EVENT_STATUS } from "utils/helpers/enums/shared.enum";

export class EventsFilterDTO{
    hostId: number;
    searchTitle: string = '';
    ageGroups: AGE_GROUPS;
    status: EVENT_STATUS;
    timeFrame: string = 'upcoming';
    isSession: string = '';
    page: number = 0;
    size: number = 8;

    offset?: number;
    count?: number;
    totalPages?: number= 0;
    // totalElements?: number= 0;
    // pageSize?: number= 0;
  
    constructor() {
      // Initialize default values if needed
      this.offset = 0;
      this.count = 0;
    }
}